import { createReducer, on } from '@ngrx/store';
import { UserApiActions } from './user.actions';
import { initialState, adapter } from './user.state';

export const usersReducer = createReducer(
  initialState,
  on(UserApiActions.usersLoaded, (state, { users }) => adapter.setAll(users, state)),
  on(UserApiActions.userAdded, (state, { user }) => adapter.addOne(user, state)),
  on(UserApiActions.userDeleted, (state, { user }) => adapter.removeOne(user.id, state))
);

const { selectIds, selectEntities, selectAll } = adapter.getSelectors();

export const selectUserIds = selectIds;

export const selectUserEntities = selectEntities;

export const selectAllUsers = selectAll;
